import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import * as LuIcons from 'react-icons/lu';
import SafeIcon from '../common/SafeIcon';

const { LuPhoneCall } = LuIcons;

const ContactPage = () => {
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContent = async () => {
      const { data } = await supabase.from('site_settings').select('setting_value').eq('setting_key', 'page_contact_us').single();
      if (data) setContent(data.setting_value);
      setLoading(false);
    };
    fetchContent();
  }, []);

  return (
    <div className="flex-1 w-full max-w-4xl mx-auto px-4 py-12">
      <div className="bg-white rounded-3xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 px-8 py-10 text-center text-white">
          <div className="w-16 h-16 bg-white/20 rounded-2xl flex items-center justify-center mx-auto mb-4 backdrop-blur-sm">
            <SafeIcon icon={LuPhoneCall} className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl font-black mb-2">اتصل بنا</h1>
          <p className="text-blue-100">نحن هنا للإجابة على استفساراتكم</p>
        </div>
        <div className="p-8 sm:p-12">
          {loading ? (
            <div className="flex justify-center py-10">
              <div className="w-8 h-8 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"></div>
            </div>
          ) : (
            <div 
              className="quill-content max-w-none text-slate-700" 
              dangerouslySetInnerHTML={{ __html: content || '<p>لم يتم إضافة محتوى لهذه الصفحة بعد.</p>' }} 
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default ContactPage;